import { useEffect } from 'react';

export const StructuredData = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "@id": "https://eap-abutments.com/#organization",
    "name": "EAP® Produktions- und Patentverwertungs-GmbH",
    "legalName": "EAP® Produktions- und Patentverwertungs-GmbH",
    "alternateName": "EAP® Abutments",
    "description": "Herstellerinformationen zu patientenindividuellen EAP® Titan-Abutments und ihrer konstruktiven Extended Anatomic Platform.",
    "url": "https://eap-abutments.com",
    "logo": "https://eap-abutments.com/images/logo-eap-full.png",
    "image": "https://eap-abutments.com/images/eap-3d-model.png",
    "telephone": "+43-677-620-565-43",
    "email": "office@eap-abutments.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Lorettostraße 26",
      "addressLocality": "Hall in Tirol",
      "postalCode": "6060",
      "addressCountry": "AT"
    },
    "foundingDate": "2009",
    "founder": {
      "@type": "Person",
      "name": "Ing. Dr. med. dent. Mario Kern M.Sc. M.Sc."
    },
    "sameAs": [
      "https://shop.eap-abutments.com",
      "https://www.linkedin.com/company/eap-produktions-und-patentverwertungs-gmbh/",
      "https://www.youtube.com/@eapabutments"
    ]
  };

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "@id": "https://eap-abutments.com/#product",
    "name": "EAP® Abutments",
    "alternateName": "Extended Anatomic Platform",
    "description": "Patientenindividuelles Titan-Abutment-Konzept. Nach Herstellerangaben ist die Geometrie darauf ausgelegt, die adhäsive Schnittstelle koronal und soweit es die individuelle Konstruktion erlaubt vom Knochen entfernt zu positionieren.",
    "brand": {
      "@type": "Brand",
      "name": "EAP®"
    },
    "image": "https://eap-abutments.com/images/eap-3d-model.png",
    "material": "Titan Grade 23",
    "category": "Dental Implant Abutments",
    "additionalProperty": [
      {
        "@type": "PropertyValue",
        "name": "Regulatorischer Status",
        "value": "Patientenindividuelle Sonderanfertigung gemäß Verordnung (EU) 2017/745 (MDR), Art. 2(3), mit Dokumentation nach Anhang XIII; keine CE-Kennzeichnung nach den Sonderanfertigungsbestimmungen"
      },
      {
        "@type": "PropertyValue",
        "name": "Anwenderkreis",
        "value": "Nur für zahnmedizinische Fachkreise"
      }
    ],
    "manufacturer": {
      "@id": "https://eap-abutments.com/#organization"
    },
    // No Offer node: patient-specific custom-made devices are quoted case by
    // case in the professionals-only shop; a price of 0 EUR would be incorrect.
    "audience": {
      "@type": "Audience",
      "audienceType": "Dental professionals"
    }
  };

  // FAQ structured data lives on /faq, generated from the questions that are
  // visible there. No separate homepage FAQ schema.



  // BreadcrumbList for homepage
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://eap-abutments.com/"
      }
    ]
  };

  // VideoObject for EAP Trailer
  const videoSchema = {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "@id": "https://eap-abutments.com/#video",
    "name": "EAP® Abutments - Die neue Generation Dental-Abutments",
    "description": "Offizielles Produktvideo des Herstellers zum patientenindividuellen EAP®-Abutment-Konzept und seinen Konstruktionsmerkmalen.",
    "thumbnailUrl": "https://eap-abutments.com/images/eap-3d-model.png",
    "uploadDate": "2024-01-01",
    "duration": "PT2M30S",
    "contentUrl": "https://eap-abutments.com/videos/eap-trailer-de.mp4",
    "embedUrl": "https://eap-abutments.com/videos/eap-trailer-de.mp4",
    "inLanguage": ["de", "en"],
    "publisher": {
      "@id": "https://eap-abutments.com/#organization"
    }
  };

  useEffect(() => {
    // Remove existing scripts to avoid duplicates
    const existingScripts = document.querySelectorAll('script[type="application/ld+json"][data-structured-data="true"]');
    existingScripts.forEach(script => script.remove());

    // Add structured data scripts
    // Note: the FAQPage schema is intentionally NOT emitted here. It lives on
    // /faq, where the same questions and answers are visible on the page.
    const scripts = [
      organizationSchema,
      productSchema,
      breadcrumbSchema,
      videoSchema
    ];

    scripts.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-structured-data', 'true');
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    // Add canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://eap-abutments.com/');

    return () => {
      // Cleanup on unmount
      const scripts = document.querySelectorAll('script[type="application/ld+json"][data-structured-data="true"]');
      scripts.forEach(script => script.remove());
    };
  }, []);

  return null;
};
